// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"753":"4fde566b4f96bca3","935":"4e42d9b1123735bd"}[chunkId] + ".js";
};